import service from "@/utils/request";

export function getSupplierPage(params) {
  return service.get("/uic-system/api/stock/supplier/page", {
    params: {
      current: params?.current || 1,
      size: params?.size || 20,
    },
  });
}

export function getSupplierList(params) {
  return service.get("/uic-system/supplier/page", {
    params: {
      supplierName: params?.supplierName || "",
    },
  });
}

export function getStockWareList() {
  return service.get("/uic-system/api/stock/ware/list");
}

export function getWareListByParentId(params) {
  return service.get("/uic-system/api/warein/getWareListByParentId", {
    params: {
      id: params?.id,
    },
  });
}

export function getMaterialGroupPage(params) {
  return service.get("/uic-system/api/stock/materialGroup/page", {
    params: {
      current: params?.current || 1,
      size: params?.size || 10,
    },
  });
}

export function getMaterialPage(params) {
  return service.get("/uic-system/api/stock/material/page", {
    params: {
      current: params?.current || 1,
      size: params?.size || 10,
    },
  });
}

export function getMaterialList(params) {
  return service.get("/uic-system/api/stock/material/list", {
    params: {
      materialDesc: params?.materialDesc || "",
    },
  });
}

export function getPalletPage(params) {
  return service.get("/uic-system/api/stock/pallet/page", {
    params: {
      current: params?.current || 1,
      size: params?.size || 20,
    },
  });
}

export function getPalletCodeList(params) {
  return service.get("/uic-system/api/stock/palletCode/list", {
    params: {
      palletCode: params?.palletCode || "",
    },
  });
}

export function getPalletDetail(params) {
  return service.get("/uic-system_hf/materialstockdetail/pallet/detail", {
    params: {
      palletCode: params?.palletCode || "",
      current: params?.current || 1,
      size: params?.size || 20,
      materialAndId: params?.materialAndId || "",
      supplierId: params?.supplierId || "",
    },
  });
}

export function getMaterialStockPage(params) {
  return service.get("/uic-system/hf_materialstock/materialstock/page", {
    params: {
      palletCode: params?.palletCode || "",
      current: params?.current || 1,
      size: params?.size || 20,
      materialAndId: params?.materialAndId || "",
      supplierId: params?.supplierId || "",
    },
  });
}

export function getWarePage(params) {
  return service.get("/uic-system/ware/page", {
    params: {
      wareNo: params?.wareNo || "",
      wareType: params?.wareType || 2,
      current: params?.current || 1,
      size: params?.size || 20,
    },
  });
}

export function searchMaterialByNo(params) {
  const queryParams = {
    materialNo: params?.materialNo || "",
    type: params?.type || 1,
    current: params?.current || 1,
    size: params?.size || 20,
    isCompose: params?.isCompose || 0,
  };
  if (params?.supplierId) {
    queryParams.supplierId = params.supplierId;
  }
  return service.get("/uic-system/material/page", {
    params: queryParams,
  });
}

export function getMaterialDetail(id) {
  return service.get("/uic-system/material/detail", {
    params: { id },
  });
}
